/**
 * Scopes defined by TPP.
 */
export enum ScopeMandatory {

    /**
     * Možnost zadat platbu / Access to payment initiation
     */
    PISP = 'SHARED.PERMISSIONS.PISP',

    /**
     * Přístup k informacím o účtech / Access to account information
     */
    AISP = 'SHARED.PERMISSIONS.AISP',

    /**
     * Vydavatel karetních platebních prostředků / TODO business doda pres Luda
     *
     * Specific to cards only.
     */
    CISP = 'SHARED.PERMISSIONS.CISP',

    /**
     * TODO business doda pres Luda
     */
    KYC = 'SHARED.PERMISSIONS.KYC',

    /**
     * Přístup k informacím o účtech / Access to account information
     */
    'SIBLINGS.ACCOUNTS' = 'SHARED.PERMISSIONS.SIBLINGS_ACCOUNTS',

    /**
     * Možnost zadat platbu / Access to payment initiation
     */
    'SIBLINGS.PAYMENTS' = 'SHARED.PERMISSIONS.SIBLINGS_PAYMENTS',

    /**
     * Přístup k informacím o účtech společnosti / Access to Company Account Information
     */
    CORACT = 'SHARED.PERMISSIONS.CORACT',

    /**
     * Přístup k informacím o Vašich účtech / Access your account information
     */
    PERACT = 'SHARED.PERMISSIONS.PERACT',

    /**
     * Možnost zadat platbu / Possibility to enter a payment
     */
    PERPAY = 'SHARED.PERMISSIONS.PERPAY'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/permissions/scope-mandatory.enum.ts